export function isElementIntersectingViewport(rect, viewportHeight) {
  return rect.bottom > 0 && rect.top < viewportHeight
}

export function shouldShowCompactTalentSummary(heroIsIntersecting) {
  return heroIsIntersecting === false
}
